import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { NsideIdentityService } from '../../shared/services/auth/nSideIdentityService';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { User } from '../../shared/models/user';
import { UserDataService } from '../../shared/services/auth/userData.service';

@Component({
  selector: 'redirect',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './redirect.component.html',
  styleUrl: './redirect.component.css'
})
export class RedirectComponent {
  private readonly nSideIdentityService: NsideIdentityService = inject(NsideIdentityService);
  private readonly userDataService: UserDataService = inject(UserDataService);

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private router: Router
  ) {
  }

  isLoggedIn$ = this.nSideIdentityService.checkAuth().pipe(
    map((authData) => {
      if (isPlatformBrowser(this.platformId)) {
        if (authData.isAuthenticated) {
          const userData: User = authData.userData;
          if (userData.user_data) {
            // Set userData in cookie (serialized to a string)
            // this.cookieService.set('userData', JSON.stringify(userData), { expires: 1 }); // Expires in 1 days
          }

          // Get the returnUrl from query parameters
          const returnUrl = localStorage.getItem("current_route") || '/cases'; // Default to /cases
          this.router.navigate([returnUrl]);
          return true;
        } else {
          // Redirect to unauthorized if not authenticated
          this.router.navigate(['unauthorized']);
          return false;
        }
      }
      return false;
    })
  );

}
